import { BorderRadius, Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const FinaliseStepWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: ${Spacing.S24};
  width: 100%;
  min-height: 0;
`

export const SummaryContent = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  justify-content: center;
  min-height: 0;
  overflow: auto;
`

export const Summary = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.S24};
  width: 100%;
  max-width: 700px;
`

export const NumberCards = styled.div`
  display: grid;
  gap: ${Spacing.S16};
  grid-template-columns: repeat(3, minmax(0, 1fr));
`

export const NumberCard = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: ${Spacing.S4};
  min-width: 0;
  padding: ${Spacing.S24};
  border: 1px solid ${Color.Grey200};
  border-radius: ${BorderRadius.R8};
`
